import { TTailwindString } from './tailwindcss.generated';
// Allows use of negative values for tailwind classes with typedUtilityClassNames.
// Usage, for example, for margin:
//
// import type { TMargin } from '@style';
// const classNames = typedUtilityClassNames(tailwindClassNameConvertNegative<TMargin>('-mx-4'));
//
export const tailwindClassNameConvertNegative = function <TTailwindCssType extends string>(
  negativeValue: `-${TTailwindCssType}`,
) {
  return negativeValue as TTailwindString;
};
